//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { ref, computed, onMounted } from '@vue/composition-api'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import { useRouter } from '@core/utils'
import { getVideoPlaybackType } from '@api'

export default {
  components: {
    videoPlayer,
  },
  setup() {
    const videoData = ref(null)
    const refVideo = ref(null)
    const refUsername = ref(null)
    const players = ref({})
    const logo = ref(require('@/assets/images/icons/logo.png'))
    const source = ref('https://static.smartisanos.cn/common/video/smartisan-tnt-jianguo.mp4')
    const initdone = ref(false)
    const cover = ref(
      'https://static.smartisanos.cn/pr/assets/images/smartisan-tnt-jianguo.190162f215c4f5f2aaabf38e5782b3af.jpg',
    )

    const playerOptions = ref({
      controls: true,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: true,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      poster: 'https://fanaty-api-stage.s3.amazonaws.com/no-thumb.jpg',
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      start: 10,
      end: 15,
    })
    const { route } = useRouter()
    const refVideoPlayer = ref(null)
    const player = computed(() => refVideoPlayer.value.player)

    const onPlayerTimeupdate = auxPlayer => {
      if (auxPlayer.currentTime() >= 15 && videoData.value && videoData.value.video_type === 'H') {
        initdone.value = false
        auxPlayer.currentTime(10)
      }
    }

    const onPlayerCanplaythrough = auxPlayer => {
      if (!initdone.value && videoData.value && videoData.value.video_type === 'H') {
        auxPlayer.currentTime(10)
        initdone.value = true
      }
    }

    const playerReadied = auxPlayer => {
      if (!initdone.value && videoData.value && videoData.value.video_type === 'H') {
        auxPlayer.currentTime(10)
        initdone.value = true
      }
    }

    onMounted(async () => {
      refVideo.value = route.value.params.playback

      const response = await getVideoPlaybackType(refVideo.value, 'S', refUsername.value)
      videoData.value = response.data

      playerOptions.value.sources.push({
        type: 'video/mp4',
        src: videoData.value.video_link,
      })
    })

    return {
      videoData,
      refVideo,
      refUsername,
      players,
      logo,
      initdone,
      source,
      cover,

      onPlayerTimeupdate,
      onPlayerCanplaythrough,
      playerReadied,
      player,
      playerOptions,
      videoPlayer,
    }
  },
}
